import * as tslib_1 from "tslib";
import * as React from 'react';
export var withStrictMode = function (Component) {
    return function (props) { return (React.createElement(React.StrictMode, null,
        React.createElement(Component, tslib_1.__assign({}, props)))); };
};
//# sourceMappingURL=strictMode.js.map